import * as angular from "angular";
import {IController} from "angular";

export class ShipperAccountsTableCtrl implements IController {

  infiniteScroll: any;
  enableRemove: any;

  onSelect: Function;
  onRemove: Function;
}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountsTable', {
    bindings: {
      infiniteScroll: '<',
      enableRemove: '<?',
      onSelect: '&?',
      onRemove: '&?'
    },
    template: require('./shipper-accounts-table.html').default,
    controller: ShipperAccountsTableCtrl
  });
